module.exports = __webpack_public_path__ + "static/01-213a1e7e756fbd564c48d253917afd76.jpg";